// src/components/JobsList.jsx
import React, { useEffect } from 'react';

const JobsList = ({ jobs, onJobSelect, selectedJobId }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    // Create date object from the UTC time
    const date = new Date(dateString);
    // This will convert to local time with a clear format
    return date.toLocaleString();
  };

  const getStatusClass = (status) => {
    switch(status) {
      case 'success': return 'status-success';
      case 'in_progress': return 'status-in-progress';
      case 'failed': return 'status-failed';
      case 'skipped': return 'status-skipped';
      case 'partial_success': return 'status-warning';
      default: return '';
    }
  };

  // preset the selected job ID to the first job if none is selected
  useEffect(() => {
    if (jobs.length > 0 && !selectedJobId) {
      onJobSelect(jobs[0].job_id);
    }
  }, [jobs, selectedJobId, onJobSelect]);

  return (
    <div className="jobs-list">
      <h2>Transfer Jobs</h2>
      <div className="list-header">
        <span className="business-col">Business</span>
        <span className="date-col">Scheduled</span>
        <span className="status-col">Status</span>
      </div>
      <div className="jobs-container">
        {jobs.length === 0 ? (
          <div className="no-jobs">No jobs found</div>
        ) : (
          jobs.map(job => (
            <div 
              key={job.job_id} 
              className={`job-item ${selectedJobId === job.job_id ? 'selected' : ''}`}
              onClick={() => onJobSelect(job.job_id)}
            >
              <span className="business-col">{job.business_name}</span>
              <span className="date-col">{formatDate(job.scheduled_at)}</span>
              <span className={`status-col job-status ${getStatusClass(job.status)}`}>
                {job.status === 'in_progress' 
                  ? 'Pending' 
                  : job.status === 'partial_success'
                    ? 'Warning'
                    : job.status}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default JobsList;